import { actionTypes as types } from '../constants'

const initialState = {
  // isFetching is used to determine whether data is available.
  isFetching: false,
  // Display error page
  fetchError: null,
  // Display success page
  fetchSuccessAction: '',
  // Display retry request page
  fetchRetry: null,
  // Array of addresses
  cards: {},
}

const fetchingState = () => ({
  isFetching: true,
  fetchError: null,
  fetchSuccessAction: '',
})

const successState = (action) => ({
  isFetching: false,
  fetchRetry: null,
  fetchSuccessAction: action.type,
})

const failureState = (action) => ({
  isFetching: false,
  fetchError: action.fetchError,
  fetchRetry: action.fetchRetry,
})

function classifiedCardData(state = initialState, action: any = {}) {
  switch (action.type) {
    case types.SHOW_CLASSIFIED_CARD_DATA:
      return {
        ...state,
        ...fetchingState(),
      }

    case types.SHOW_CLASSIFIED_CARD_DATA_SUCCESS:
      return {
        ...state,
        ...successState(action),
        cards: {
          ...state.cards,
          [action.cardId]: action.card,
        },
      }

    case types.SHOW_CLASSIFIED_CARD_DATA_FAILURE:
      return {
        ...state,
        ...failureState(action),
      }

    case types.CLASSIFIED_CARD_DATA_ERASE:
      return initialState

    default:
      return state
  }
}

export default classifiedCardData
